// extracted by mini-css-extract-plugin
export default {"tooltip":"CB-z","arrow":"DB-z"};